export function formatBrDateToISO8601(brDate: string) {
  const [day, month, year] = brDate.split('/');

  if (!day || !month || !year) {
    throw new Error('Invalid date format');
  }

  const dayWithLeadingZero = day.padStart(2, '0');
  const monthWithLeadingZero = month.padStart(2, '0');

  const iso8601Date = `${year}-${monthWithLeadingZero}-${dayWithLeadingZero}`;

  return iso8601Date;
}
